import React from "react";

export default function UpdateSuccess() {
  return (
    <div className="page1">You have successfully update your subscription.</div>
  );
}
